import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createUserEntityInfo } from 'record-it-time-common/entity/entities/User/createUserEntityInfo';
import { User } from './userTypes';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';

export const userEntityInfo = createUserEntityInfo<User>({
  additionalFieldInfos:
    EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
});
